'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RichMedia = require('../RichMedia');

var _RichMedia2 = _interopRequireDefault(_RichMedia);

var _MapPreviewOverlay = require('./MapPreviewOverlay');

var _MapPreviewOverlay2 = _interopRequireDefault(_MapPreviewOverlay);

require('./MapMedia.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapMedia = function MapMedia(_ref) {
    var element = _ref.element,
        width = _ref.width,
        gridSize = _ref.gridSize;
    return _react2.default.createElement(_RichMedia2.default, { className: 'MapMedia', element: element, width: width, gridSize: gridSize,
        OverlayComponent: _MapPreviewOverlay2.default });
};

// Styles


// Components
// Lib


MapMedia.propTypes = {
    element: _propTypes2.default.object.isRequired,
    width: _propTypes2.default.number,
    gridSize: _propTypes2.default.number
};

exports.default = MapMedia;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/map/MapMedia.js
// module id = 2014
// module chunks = 0